import { Injectable } from '@angular/core';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { HttpModule } from '@angular/http';
import { Observable, BehaviorSubject } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import { SPOTLIGHT } from '../../../assets/js/spotlight';

@Injectable({
  providedIn: 'root'
})
export class SearchService {
  // private cookie = JSON.parse(this._cookie.get('portal'));
  private url = 'http://189.126.197.169/node/server/index.js?service=SearchMaterial.svc/searchTermo/&query='
  // private url = '//services.focustextil.com.br/node/server/index.js?service=SearchMaterial.svc/searchTermo/&query='

  private searchSource = new BehaviorSubject({});
  searchList = this.searchSource.asObservable();
  spotlight = SPOTLIGHT;

  constructor(
    private http: HttpClient,
    private _cookie: CookieService
  ) { }

  search(searchTerm): Observable<any> {
    let spots = this.spotlight.reduce((init, current) => {
      if ( current.value.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1 ) {
        let desc = current.desc;
        if ( init.hasOwnProperty(desc) ) {
          init[desc].push(current.value);
        } else {
          init[desc] = [];
          init[desc].push(current.value);
        }
      }
      return init;
    }, {});

    if (!this.isEmptyObject(spots)) {
      this.searchSource.next(spots);
    } else {
      this.searchTermo(searchTerm).subscribe(
        (response: any) => {
          let spots = {}
          spots['TERMO'] = response.map(res=>res.WORD);
          this.searchSource.next(spots);
        }
      );
    }
    return
  }

  searchTermo(term): Observable<any> {
    return this.http.get<any>(this.url + term)
  }

  isEmptyObject(obj) {
    for(var prop in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, prop)) {
        return false;
      }
    }
    return true;
  }
}
